import { exact, number, string } from "prop-types";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import { Card, Heading } from "uikit/components";
import cx from "classnames";
import styles from "./MunicipalitySummaryCard.module.styl";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";
import Chart from "react-apexcharts";
import React from "react";
import { BuildReportFileTrigger } from "components/index";
import { ReportFormat } from "api/Enums";
import MunicipalitySummaryApiClient from "api/MunicipalitySummaryApiClient";

export default function MunicipalitySummaryCard({
    title,
    value,
    percentage,
    info,
    descriptionTitle,
    descriptionText,
    municipalityId,
    municipalityPositionModel,
    dataTestName,
}) {
    const options = {
        labels: [""],
        fill: {
            type: "solid",
            colors: [percentageLevels.indicatorColor(percentage).color],
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: "75%",
                },
                track: {
                    background: "#C4C4C4",
                    strokeWidth: "35%",
                    margin: 2,
                },
                dataLabels: {
                    showOn: "always",
                    value: {
                        offsetY: -5,
                        color: "#082254",
                        fontSize: "24px",
                        show: true,
                        fontFamily: "Montserrat",
                        fontWeight: "600",
                    },
                },
            },
        },
    };
    const series = [percentage];

    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={cx(styles.form, percentageLevels.indicatorColor(percentage).style)}
            name={dataTestName}
        >
            <div className={styles.content}>
                <div>
                    <div className={styles.heading}>
                        <Heading size={"h2"}>{title}</Heading>
                        <div className={styles.icon}>
                            <IconTooltip trigger={"hover"}>
                                <div className={styles.infoPanel}>{info}</div>
                            </IconTooltip>
                        </div>
                    </div>
                    <div className={styles.indicators}>
                        <div>
                            <div className={styles.indicator}>
                                <div className={styles.numerator}>{value}</div>
                            </div>
                            <div className={styles.municipalityRatingTitle}>{descriptionTitle}</div>
                        </div>
                    </div>
                    <div className={styles.linkContainer}>
                        <div className={styles.descriptionText}>{descriptionText}</div>
                        <BuildReportFileTrigger
                            startBuildingReportFunc={() =>
                                MunicipalitySummaryApiClient.buildMunicipalitySummary(
                                    municipalityId,
                                    ReportFormat.Excel,
                                )
                            }
                            formatIcon="Excel"
                            triggerText="Скачать подробный отчет"
                            downloadText="Скачать Excel-отчет"
                        />
                    </div>
                </div>
                <div className={styles.chart}>
                    <Chart options={options} series={series} type="radialBar" width="185" />
                    <div
                        className={cx(
                            styles.percentageText,
                            percentageLevels.indicatorColor(percentage).textStyle,
                        )}
                    >
                        {percentage >= percentageLevels.normal
                            ? percentage >= percentageLevels.good
                                ? "высокий уровень цифровизации"
                                : "средний уровень цифровизации"
                            : "низкий уровень цифровизации"}
                    </div>
                </div>
            </div>
        </Card>
    );
}

MunicipalitySummaryCard.propTypes = {
    title: string.isRequired,
    percentage: number.isRequired,
    value: number.isRequired,
    info: string.isRequired,
    descriptionTitle: string.isRequired,
    descriptionText: string.isRequired,
    municipalityId: number.isRequired,
    dataTestName: string.isRequired,
    municipalityPositionModel: exact({
        municipalityPosition: number.isRequired,
        municipalityCount: number.isRequired,
        municipalityRatingText: string.isRequired,
    }).isRequired,
};
